export const m1l1Solution = `use debug::PrintTrait;
// do not modify code on this line or above

//TODO: make this function compile by properly declaring the variable
fn main() {
    let x = 10;
    if x == 10 {
        ('x is ten!').print();
    } else {
        ('x is not ten!').print();
    }
}

// do not modify code on this line or below

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
